import { ReactElement } from 'react';

const TwitterIcon = (props: TClassNameProps): ReactElement => (
	<svg width="18" height="14.628" viewBox="0 0 18 14.628" {...props}>
		<path
			id="iconmonstr-twitter-1"
			d="M18,3.98a7.373,7.373,0,0,1-2.121.581A3.7,3.7,0,0,0,17.5,2.518a7.4,7.4,0,0,1-2.345.9A3.7,3.7,0,0,0,8.864,6.782,10.484,10.484,0,0,1,1.253,2.924,3.7,3.7,0,0,0,2.4,7.854,3.677,3.677,0,0,1,.724,7.392,3.7,3.7,0,0,0,3.686,11.06a3.7,3.7,0,0,1-1.668.063,3.7,3.7,0,0,0,3.45,2.564A7.425,7.425,0,0,1,0,15.217a10.454,10.454,0,0,0,5.661,1.659,10.444,10.444,0,0,0,10.5-10.985A7.519,7.519,0,0,0,18,3.98Z"
			transform="translate(0 -2.248)"
			fill="currentColor"
		/>
	</svg>
);

export default TwitterIcon;
